<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">下載轄下資料</h3>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-8">
                    <select v-model="ceadcd" class="form-control">
                        <option  value="2">區部</option>
                        <option  value="3">區部轄下通訊處</option>
                        <option v-if="this.dis=='51'" value="5">專招轄下推展處</option>
                        <!-- <option v-if="this.dis=='51'" value="71">專招轄下股長</option> -->
                        <option v-if="this.dis=='51'" value="4">展業轄下展業課</option>
                        <option v-if="this.dis=='51'" value="6">展業轄下展業區</option>
                        <!-- <option v-if="this.dis=='51'" value="74">展業轄下收展員</option>  -->
                    </select>
                </div>
                <div class="col-4 text-left">
                    <a class="btn btn-default" style="margin:0px;" @click="$emit('choose', ceadcd)">下載轄下資料</a>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ceadcdChooseModal',
  data () {
    return {
        ceadcd:''
    }
  },
  props: {
    open: {
        type: Boolean,
        default: false
    },
    dis: {
        type: String,
        default: ''
    }
  }
}
</script>
